<!--<div [ngClass]="widthClass">-->
<ng-container [ngSwitch]="fdef.fieldtype">

    <ng-container *ngSwitchCase="'email'">
        <div class="box">
            <span class="displayfield">
                <label *ngIf="label">{{label}}</label>
                <span class="mail value-span"><a href="mailto:{{value}}">{{value}}</a></span>
            </span>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'currency'">
        <div class="box">
            <span class="displayfield">
                <label *ngIf="label">{{label}}</label>
                <span class="value-span">{{value | currency:"EUR":true}}</span>
            </span>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'image'">
        <div class="box">
            <span class="displayfield">
                <label *ngIf="label">{{label}}</label>
                <br>
                <img *ngIf="value" [src]="value" alt="Image" width="250">
            </span>
        </div>
    </ng-container>

    <ng-container *ngSwitchDefault>
        <div class="box">
            <span class="displayfield">
                <label *ngIf="label">{{label}}</label>
                <span class="value-span">{{value}}</span>
            </span>
        </div>
    </ng-container>
    
</ng-container>
<!--</div>-->
